import tyraPic from "@/public/images/artists/tyra.png";
import { Artist } from "@/types/types";

export const tyra = {
  id: "214",
  name: "Tyra",
  image: tyraPic,
  description: `Tyra's voice carries the smooth, bright timbre of 90s R&B, with a subtle vibrato that adds warmth. Her delivery is laid-back and poised, with a mature depth that brings soulful weight to her sound.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Ftyra-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Unprocessed", "RnB", "Mature", "Ballads"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Mid",
        high: "High",
      },
      specific: {
        low: 57,
        high: 72,
      },
      sweetSpot: 64,
    },
  },
} as const satisfies Artist;
